/* eslint-disable */
import { useEffect } from "react";
// import { useTranslation } from "react-i18next";

const Logout = () => {
  const token = localStorage.getItem("token");

  /* ------------- Language translation imports starts here ------------- */
  //   const { i18n } = useTranslation();

  useEffect(() => {
    try {
      if (token) {
        // Remove items from localStorage by their key names
        localStorage.removeItem("token");
        localStorage.removeItem("userInfo");
        localStorage.removeItem("userID");
        localStorage.removeItem("ecosystem");
        localStorage.removeItem("ecosystemlogo");

        window.location.reload();
        //   i18n.changeLanguage("en");
      }
    } catch (error) {
      console.log(error.message);
    }
  }, [token]);
};

export default Logout;
